import { NgModule } from '@angular/core';
import { S125gS125m01Component } from './s125g-s125m01.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S125gS125m01Component]
})
export class S125gModule { }

